/**
 *
 * @param {Map<String, any>} applied
 * @param {String} original Original class name
 * @param {String} hash
 * @param {String} target
 */
const setAppliedClasses = (applied, original, hash, target) => {
  const name = original.slice(1);

  if (!applied.has("class")) {
    applied.set("class", new Map());
  }
  if (!applied.get("class").has(target)) {
    applied.get("class").set(target, new Map());
  }
  if (!applied.get("class").get(target).has(name)) {
    applied.get("class").get(target).set(name, new Set());
  }

  applied.get("class").get(target).get(name).add(hash);
}

export default setAppliedClasses;